module.exports = __webpack_public_path__ + "img/img_8.db3e35d7.jpg";